
export default {
  API_URL: 'https://api.fandisentinel.com/',
  DisableGoogleAnalytics: false,
  AUTHORIZE_NET_URL: 'https://accept.authorize.net/payment/payment',
};
